import { ActionIcon, Card } from "@insights/ui";
import type { EngineeringHealthMetric } from "@insights/contracts";
import { ChartNoAxesCombined, ScanSearch } from "lucide-react";
import { formatHealthValue } from "../helpers/format-health-value";

export function MetricCard({
  metric,
  onChart,
  onInspect,
}: {
  metric: EngineeringHealthMetric;
  onChart: () => void;
  onInspect: () => void;
}) {
  const distributionUnit = metric.id === "open-pr-wip" || metric.id === "stale-prs"
    ? "milliseconds"
    : metric.unit;

  return (
    <Card as="section" className="health-metric-card">
      <div className="health-metric-header">
        <h2>{metric.label}</h2>
        <div className="health-metric-actions">
          {metric.series.length > 0 && (
            <ActionIcon
              icon={<ChartNoAxesCombined />}
              label={`View weekly chart for ${metric.label}`}
              onClick={onChart}
              size="small"
            />
          )}
          {metric.status === "available" && (
            <ActionIcon
              icon={<ScanSearch />}
              label={`Inspect evidence for ${metric.label}`}
              onClick={onInspect}
              size="small"
            />
          )}
        </div>
      </div>
      {metric.status === "available" ? (
        <>
          <strong className="health-metric-value">{formatHealthValue(metric.value, metric.unit)}</strong>
          {metric.changePercent !== null && <p>{Math.abs(metric.changePercent).toFixed(0)}% {metric.changePercent >= 0 ? "higher" : "lower"} than the prior period</p>}
          {metric.distribution && <div className="health-distribution" aria-label={`${metric.label} percentile distribution`}><span>P10 {formatHealthValue(metric.distribution.p10, distributionUnit)}</span><span>P75 {formatHealthValue(metric.distribution.p75, distributionUnit)}</span><span>P90 {formatHealthValue(metric.distribution.p90, distributionUnit)}</span></div>}
          {metric.outlierCount > 0 && <p>{metric.outlierCount} persistent cohort {metric.outlierCount === 1 ? "outlier" : "outliers"}</p>}
        </>
      ) : <p className="health-unavailable">{metric.unavailableReason}</p>}
    </Card>
  );
}
